var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.002C12.4183 16.002 16 12.4202 16 8.00195C16 3.58368 12.4183 0.00195312 8 0.00195312C3.58172 0.00195312 0 3.58368 0 8.00195C0 12.4202 3.58172 16.002 8 16.002Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99844 9.40117C8.32644 9.40117 8.59844 9.12917 8.59844 8.80117V4.80117C8.59844 4.47317 8.32644 4.20117 7.99844 4.20117C7.67044 4.20117 7.39844 4.47317 7.39844 4.80117V8.80117C7.39844 9.12917 7.67044 9.40117 7.99844 9.40117Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73522 10.8983C8.69522 10.8022 8.63922 10.7143 8.56722 10.6343C8.48722 10.5623 8.39922 10.5063 8.30322 10.4663C8.11122 10.3862 7.88722 10.3862 7.69522 10.4663C7.59922 10.5063 7.51122 10.5623 7.43122 10.6343C7.35922 10.7143 7.30322 10.8022 7.26322 10.8983C7.22322 10.9942 7.19922 11.0983 7.19922 11.2023C7.19922 11.3063 7.22322 11.4102 7.26322 11.5062C7.30322 11.6102 7.35922 11.6902 7.43122 11.7702C7.51122 11.8422 7.59922 11.8983 7.69522 11.9383C7.79122 11.9783 7.89522 12.0023 7.99922 12.0023C8.10322 12.0023 8.20722 11.9783 8.30322 11.9383C8.39922 11.8983 8.48722 11.8422 8.56722 11.7702C8.63922 11.6902 8.69522 11.6102 8.73522 11.5062C8.77522 11.4102 8.79922 11.3063 8.79922 11.2023C8.79922 11.0983 8.77522 10.9942 8.73522 10.8983Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.b03082df83f625d10a6c7c33ba4ad379.svg";
export { ForwardRef as ReactComponent };